module.exports = __webpack_public_path__ + "img/uganda-rec.c2f7d246.svg";